import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    background-color: #ffffff;
    border-radius: 12px;
    border: 1px solid #f0f1f3;
    gap: 32px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 24px 16px;
    }
`;

export const LeftColumn = styled.div`
    min-width: 200px;
    max-width: 300px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
        justify-content: flex-start;
        padding-bottom: 8px;
    }
`;

export const ContentWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export const TopicWrapper = styled.div`
    display: flex;
    flex-direction: row;
    background-color: #f0f1f3;
    border-radius: 8px;
    padding: 0;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const TopicLeftColumn = styled.div`
    min-width: 200px;
    max-width: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 0;
    background-color: #f0f1f3;
    border-radius: 8px;

    @media (max-width: 768px) {
        justify-content: flex-start;
        padding: 12px 16px;
    }
`;

export const TopicContent = styled.div`
    flex: 1;
    padding: 16px 32px;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        padding: 16px;
    }
`;

export const FieldWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
`;

export const FieldItem = styled.div`
    flex: 1 1 300px;
    min-width: 250px;
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    @media (max-width: 480px) {
        min-width: 100%;
    }
`;

export const FieldLabel = styled.label`
    font-weight: 500;
    margin-bottom: 4px;
    font-size: 14px;
    color: #333;
`;
